import { useState, useEffect, useCallback } from 'react';
import EulerBeatsWrapper, { Chord } from 'utils/EulerBeatsWrapper';

let interval;
const usePlayback = () => {
  const [playbackRate, setPlaybackRate] = useState(1);
  const [currentTimePercentage, setCurrentTimePercentage] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [lastChordIndex, setLastChordIndex] = useState<number | undefined>(undefined);
  const [lastChordIsPlaying, setLastChordIsPlaying] = useState(false);
  const [lastChordProgress, setLastChordProgress] = useState<number | undefined>(undefined);
  const [chords, setChords] = useState<Chord[]>();

  useEffect(() => {
    interval = setInterval(() => {
      const playerState = EulerBeatsWrapper.audio.getPlayerState();
      if (playerState) {
        setCurrentTimePercentage(playerState.currentTimePercentage);
        setCurrentTime(playerState.currentTime);
        setDuration(playerState.duration);
        setLastChordIndex(playerState.lastChordIndex);
        setLastChordIsPlaying(playerState.lastChordIsPlaying);
        setLastChordProgress(playerState.lastChordProgress);
        setChords(playerState.chords);
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const audioRewind = useCallback(() => {
    setCurrentTimePercentage(0);
    setCurrentTime(0);
    setPlaybackRate(1);
    setLastChordIndex(undefined);
    EulerBeatsWrapper.audio.rewind();
  }, []);

  return {
    playbackRate,
    setPlaybackRate,
    currentTimePercentage,
    currentTime,
    duration,
    lastChordIndex,
    lastChordIsPlaying,
    lastChordProgress,
    chords,
    setCurrentTimePercentage,
    setCurrentTime,
    audioRewind,
  };
};

export default usePlayback;
